import React, { useState } from "react";
import { Stack, Text, Icon, IStackTokens, NeutralColors } from "@fluentui/react";

const accordionTokens: IStackTokens = { childrenGap: 10 }; 
const panelTokens: IStackTokens = { childrenGap: 8 }; 
interface AccordionItemProps {
  header: string;
  children: React.ReactNode;
  value: string;
}

export const AccordionItem=(props:AccordionItemProps)=>{
  const [isOpen, setIsOpen] = useState(true);
  const togglePanel = () => setIsOpen(!isOpen);
  return (
    <Stack tokens={accordionTokens} styles={{ root: { borderBottom: "1px solid #ccc", paddingBottom: 10 } }}>
      <div
        onClick={togglePanel}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <Text variant="medium" styles={{ root: { color:NeutralColors.gray130 } }}>
          {props.header}
        </Text>
        <Icon iconName={isOpen ? "ChevronUp" : "ChevronDown"} />
      </div>
      {isOpen && (
        <Stack tokens={panelTokens} styles={{ root: { marginTop: 10 } }}>
          {props.children}
        </Stack>
      )}
    </Stack>
  );
};



